import { useConnect } from '@lore/query-connect';
import useStewardshipFilter from '../../../projects/useStewardshipFilter';
import REQUIRED_FIELDS from '../../../projects/REQUIRED_FIELDS';
import { tags_educator } from '../../../../utils/query-helpers';

export default function useEducatorsWhoCompletedProject(network, timestamp) {
  const stewardshipFilter = useStewardshipFilter();

  return useConnect('user.find', {
    where: {
      eager: {
        $aggregations: [
          {
            type: 'count',
            alias: 'numberOfProjects',
            relation: 'projects',
            $where: {
              // published: true,
              activityId: {
                $null: false
              },
              networkId: network?.id,
              createdAt: {
                $gte: timestamp.start,
                $lte: timestamp.end
              },
              $and: REQUIRED_FIELDS.$and
            }
          }
        ],
        $where: {
          ...tags_educator(),
          $or: stewardshipFilter
        },
        $having: {
          numberOfProjects: {
            $gte: 1
          }
        }
      },
    },
    pagination: {
      pageSize: 1
    }
  });
}
